import { render } from "./DiagnosisTabs.vue?vue&type=template&id=6559b719&scoped=true"
import script from "./DiagnosisTabs.vue?vue&type=script&lang=js"
export * from "./DiagnosisTabs.vue?vue&type=script&lang=js"

import "./DiagnosisTabs.vue?vue&type=style&index=0&id=6559b719&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6559b719"],['__file',"src/views/ProductDiagnosis/components/DiagnosisTabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6559b719"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6559b719', __exports__)) {
    api.reload('6559b719', __exports__)
  }
  
  module.hot.accept("./DiagnosisTabs.vue?vue&type=template&id=6559b719&scoped=true", () => {
    api.rerender('6559b719', render)
  })

}


export default __exports__